'use client';

import CheckMark from '@public/svg/navigation/check-mark.svg?component';
import clsx from 'clsx';

export const SwabKitProductDetailsIncluded: React.FC = () => {
  return (
    <div className="mb-8">
      <div className="text-lg leading-[27px] tracking-[-0.54px] mb-3">Included:</div>
      <span
        className={clsx(
          'font-light',
          'text-[15px] leading-[21px] tracking-[-0.45px]',
          'sm:text-base sm:leading-[22.4px] sm:tracking-[-0.48px]'
        )}
      >
        <div className="flex justify-start items-center gap-4 mb-3">
          <CheckMark />
          <div>Medical grade at-home DNA swab</div>
        </div>
        <div className="flex justify-start items-center gap-4 mb-3">
          <CheckMark />
          <div>Free return shipping label</div>
        </div>
        <div className="flex justify-start items-center gap-4 mb-3">
          <CheckMark />
          <div>Comprehensive DNA fitness & health report with 13 key traits</div>
        </div>
        <div className="flex justify-start items-center gap-4">
          <CheckMark />
          <div>Free personalized 1:1 walkthrough of health results with Fitness Expert</div>
        </div>
      </span>
    </div>
  );
};
